/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto } from '../models/Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AwardAgreementDocumentImportSharedService {

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppAwardAgreementDocumentImportAwardDocumentsByAwardId(
awardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/award-agreement-document-import/award-documents-by-award-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppAwardAgreementDocumentImportAwardDocumentsForParticipantByAwardId(
awardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/award-agreement-document-import/award-documents-for-participant-by-award-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
